import { REGIONAL_PROD_ENVS, REGIONAL_PROD_SUBDOMAINS } from 'constants/envs';

const upcUrl: Record<string, string> = {
  prod: 'https://partner.alta.avigilon.com',
  dev: 'https://partner.dev.alta.avigilon.com',
  sandbox: 'https://partner.sandbox.alta.avigilon.com',
  mine: 'http://localhost:3000/partner',
  test: 'https://partner.test.alta.avigilon.com',
};

REGIONAL_PROD_ENVS.forEach((env) => {
  upcUrl[env] =
    `https://partner.${REGIONAL_PROD_SUBDOMAINS[env]}.alta.avigilon.com`;
});

export const getUpcUrl = (region: OP.Env): string => {
  return `${upcUrl[region]}`;
};
